<template>
  <div class="store-picker-modal">
    <legacy-modal
      v-if="active"
      v-model="active"
      title="Välj butik"
    >
      <template #content>
        <div class="store-picker-modal--label-area">
          <span class="store-picker-modal--label-area--label">Sök efter butik</span>
          <!--
          <button
            class="button button--32 button--text-icon button--transparent"
            @click="getStoreByLocation"
          >
            <svgicon
              class="my-position-icon"
              name="Positions/MyPosition"
            />
            Butiker nära dig
          </button>
          -->
        </div>
        <div class="store-picker-modal--search-input input-text input-text--simple input-text--48">
          <div class="input-text__elements">
            <label
              class="input-text__label"
              for="store-search"
              v-text="'Sök på ort eller butik'"
            />
            <input
              id="store-search"
              v-model="searchQuery"
              class="input-text__element store-search--input"
              type="search"
              placeholder="Sök på ort eller butik"
              @keyup.enter="doSearch()"
            >
            <svgicon
              class="search-icon"
              name="Navigation/Search"
            />
          </div>
          <svgicon
            class="search-icon"
            name="Navigation/Search"
          />
        </div>
        <div v-if="stores || loading">
          <div
            v-if="loading"
            class="store-picker-modal--loader"
          >
            <legacy-spinner />
          </div>

          <div
            v-if="stores"
            class="store-picker-modal--results"
          >
            <p class="store-picker-modal--results-amount">
              {{ stores.length }} resultat
            </p>
            <div v-if="stores.length == 0">
              <div class="not-found">
                <svgicon
                  name="Search/Search"
                  :original="true"
                />
                <div class="no-result--text-wrapper">
                  <h3
                    class="font-rubrik-1--bold"
                    v-text="'Din sökning gav inget resultat'"
                  />
                  <p
                    class="font-text-3--regular"
                    v-text="'Kontrollera att orden är rättstavade eller försök med andra sökord.'"
                  />
                </div>
              </div>
            </div>
            <ul v-if="stores.length > 0">
              <li
                v-for="store in stores"
                :key="store.id"
                class="store-picker-modal--results-result"
              >
                <span class="store-picker-modal--results-result--name">{{ store.MarketingName }}</span>
                <button
                  class="button button--32 button--secondary"
                  type="button"
                  :aria-label="'Välj ' + store.MarketingName"
                  @click="selectStore(store)"
                  v-text="'Välj'"
                />
              </li>
            </ul>
          </div>
        </div>

        <div
          v-if="error"
          class="technical-error"
        >
          <legacy-notification
            title="Tekniskt fel"
            message="Någonting gick fel"
            type="Error"
            :active="!!error"
            :closeable="false"
          />
        </div>
      </template>
    </legacy-modal>
  </div>
</template>

<script>
import debounce from "lodash.debounce"
import LegacyModal from './modal'
import ga from '@/analytics/dataLayerTopNav.js'
import '#/Positions/MyPosition'
import '#/Navigation/Search'
import '#/Search/Search'
import LegacyNotification from './notification'
import LegacySpinner from './spinner'

export default {
  name: 'LegacyStorePickerModal',
  components: {
    LegacyModal,
    LegacyNotification,
    LegacySpinner
  },
  model: {
    prop: 'active',
    event: 'openstate'
  },
  data () {
    return {
      searchQuery: '',
      active: true,
      stores: null,
      error: null,
      loading: false
    }
  },
  watch: {
    searchQuery () {
      this.doSearch()
    },
    active: function (newVal) {
      if (newVal == false) {
        this.$emit('openstate', false)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.getElementById("store-search").focus()
    })
  },
  methods: {
    getStoreByLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        console.log('Store by location', 'unsoported browser')
      }
    },
    showPosition (position) {
      ga.storeCloseToMe()
      console.log('Latitude: ' + position.coords.latitude + ' Longitude: ' + position.coords.longitude)
    },
    doSearch: debounce(async function () {
      if (this.searchQuery.length >= 3) {
        // Reset
        this.loading = true
        this.stores = null
        this.error = false

        fetch(`${this.$root.envConfig.searchUrl}/api/store/search?query=${this.searchQuery}`)
          .then((response) => response.json())
          .then((data) => this.updateResults(this.searchQuery, data.Documents))
          .catch((err) => {
            this.loading = false
            this.error = err
          })
      }
    }, 300),
    updateResults (query, stores) {
      this.loading = false
      ga.storeSearch(query, !!stores.length > 0)
      this.stores = stores
    },
    selectStore (store) {
      ga.selectNewStore(store)
      this.$emit('update-selected-store', store)
      this.$emit('openstate', false)
    }
  }
}
</script>



<style lang="scss">
.store-picker-modal {
  @include media-breakpoint-up(lg) {
    .e6-modal-container {
      min-height: 32.5rem;
    }
  }

  &--label-area {
    display: inline-flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    width: 100%;

    &--label {
      @include font(text, 2, black);

      text-transform: uppercase;
      margin-top: auto;
    }

    .button.button--32 {
      padding: 0;
      border-radius: 0;
    }
  }

  &--search-input {
    margin: 0;

    input[type='search']::-ms-clear {
      display: none;
      width: 0;
      height: 0;
    }

    input[type='search']::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }

    /* clears the 'X' from Chrome */
    input[type='search']::-webkit-search-decoration,
    input[type='search']::-webkit-search-cancel-button,
    input[type='search']::-webkit-search-results-button,
    input[type='search']::-webkit-search-results-decoration {
      display: none;
    }

    & .input-text__element {
      background: $color-white;

      &.store-search--input {
        box-sizing: border-box;
        padding-left: 2.5rem;
        padding-right: 4.5rem;
        appearance: none;
      }

      &:focus {
        border-bottom: 2px solid $color-red;

        &.store-search--input {
          padding-left: 2.5rem;
          padding-right: 4.5rem;
          color: $color-black;
        }
      }
    }

    &--button {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(-8px, -50%);
    }

    & .search-icon {
      width: 1.25rem;
      height: 1.25rem;
      position: absolute;
      left: 0.75rem;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  &--loader {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 20rem;
  }

  &--results {
    &-amount {
      @include font(text, 2, black);

      text-transform: uppercase;
      margin-top: 1rem;
      margin-bottom: 0.75rem;

      @include media-breakpoint-up(lg) {
        margin-top: 1.5rem;
      }
    }

    &-result {
      @include font(text, 3, bold);

      margin-top: 0.75rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.75rem 0.75rem;
      border-bottom: 1px solid $color-grey-special;
      align-items: center;

      &:first-of-type {
        margin-top: 0;
      }

      .button {
        min-width: fit-content;
        margin-left: auto;
      }

      &--name {
        height: fit-content;
        white-space: pre-wrap;
        margin-right: 1rem;
        margin-bottom: auto;
        margin-top: auto;
      }
    }

    .not-found {
      background-color: $color-blue-lightest;
      display: flex;
      align-items: center;
      color: $color-blue-dark;
      padding: 1rem;
      white-space: pre-wrap;
      border-radius: 0.25rem;

      @include media-breakpoint-up(lg) {
        padding: 1.5rem;
      }

      .no-result--text-wrapper {
        display: flex;
        flex-direction: column;

        h3 {
          margin: 0 0 0.25rem 0;
        }

        p {
          margin: 0;
        }
      }

      svg {
        min-width: 2rem;
        height: 2rem;
        max-width: 2rem;
        margin-right: 1rem;

        @include media-breakpoint-up(lg) {
          min-width: 2.5rem;
          height: 2.5rem;
          max-width: 2.5rem;
        }
      }
    }
  }

  .technical-error {
    margin-top: 1rem;
  }
}
</style>
